module.exports = __webpack_public_path__ + "media/components/forecast-table/static/energy-6d18bfde779257a7a9c62c1f98f8491a.svg";